// DisplaySourceStateService
//
// Provides 

'use strict';

var moment = require('moment');
var sutl = require('../../sutl/Sutl');

angular.module('inara').factory('DisplaySourceStateService', DisplaySourceStateService);

DisplaySourceStateService.$inject = ['$rootScope', '$interval', 'RoomService'];

function DisplaySourceStateService($rootScope, $interval, RoomService) {
    var elapsedTimeInterval = null;
    var elapsedTimeNow = null;
    var sourceStates = {
        state: {
            // content sharing
            iconStates: {
                connecting: 'ion-aveo-share-screen',
                sending: 'ion-aveo-share-screen'
            }
            // no idleStates means undefined state is idle
        },
        mediaPlayerState: {
            // media player
            iconStates: {
                playing: 'ion-play',
                recording: 'ion-record',
                paused: 'ion-pause',
                reversing: 'ion-ios-rewind',
                forwarding: 'ion-ios-fastforward'
            },
            isStatelessProperty: 'isMediaPlayerStateless',
            idleStates: ['stopped']
        },
        mediaRecorderState: {
            // media recorder
            iconStates: {
                playing: 'ion-play',
                recording: 'ion-record',
                paused: 'ion-pause',
                reversing: 'ion-ios-rewind',
                forwarding: 'ion-ios-fastforward'
            },
            isStatelessProperty: 'isMediaRecorderStateless',
            idleStates: ['stopped']
        },
        mediaStreamerState: {
            // media streamer
            iconStates: {
                streaming: 'ion-aveo-broadcast',
                paused: 'ion-pause'
            },
            isStatelessProperty: 'isMediaStreamerStateless',
            idleStates: ['stopped']
        }
    };

    return {
        updateElapsedTimeInterval: updateElapsedTimeInterval,
        getFormattedElapsedTime: getFormattedElapsedTime,
        getActiveSourceStatesCount: getActiveSourceStatesCount,
        getSourceStateInfo: getSourceStateInfo
    };

    function updateElapsedTimeInterval() {
        // Only enable elapsed time interval if state is 'recording'
        if (RoomService.online() && RoomService.isRoomLoaded()) {
            var displays = sutl.getNode(RoomService.getRoom(), ['states', 'displays'], {});
            for (var displayId in displays) {
                if (!displays.hasOwnProperty(displayId)) continue;
                var sources = sutl.getNode(displays, [displayId, 'sources']);
                for (var sourceId in sources) {
                    if (!sources.hasOwnProperty(sourceId)) continue;
                    var source = sutl.getNode(sources, [sourceId]);
                    for (var stateName in getSourceStateInfo()) {
                        if (!sutl.getNode(source,
                            [getSourceStateInfo(stateName).isStatelessProperty],
                            false) &&
                            sutl.getNode(source, [stateName]) === 'recording') {
                            enableInterval(true);
                            return;
                        }
                    }
                }
            }
        }
        enableInterval(false);

        function enableInterval(enable) {
            if (!enable && elapsedTimeInterval !== null) {
                $interval.cancel(elapsedTimeInterval);
                elapsedTimeInterval = null;
                elapsedTimeNow = null;
            } else if (elapsedTimeInterval === null) {
                elapsedTimeNow = Date.now();
                elapsedTimeInterval = $interval(function() {
                    elapsedTimeNow = Date.now();
                }, 1000);
            }
        }
    }

    function getActiveSourceStatesCount(displayId, sourceId, stateName) {
        // All parameters are optional. If specified, only displays/sources/states
        // matching the specified id/stateName will be counted.
        var count = 0;
        var activeContentSources = {};
        var displayKey;
        if (!RoomService.online() || !RoomService.isRoomLoaded()) return count;
        if (angular.isDefined(displayId)) {
            displayKey = displayId;
            return countActiveStates(sutl.getNode(RoomService.getRoom(),
                ['states', 'displays', displayId, 'sources']));
        } else {
            var roomStatesDisplays = sutl.getNode(RoomService.getRoom(), 'states.displays');
            if (roomStatesDisplays === null) return 0;
            for (displayKey in roomStatesDisplays) {
                if (!roomStatesDisplays.hasOwnProperty(displayKey)) continue;
                count += countActiveStates(sutl.getNode(roomStatesDisplays,
                    [displayKey, 'sources']));
            }
        }
        return count;

        function countActiveStates(sources) {
            var count = 0;
            var sourceKey;
            if (sources === null ||
                RoomService.getRoom() === null ||
                !RoomService.getRoom().$isLoaded()) {
                return count;
            }
            for (sourceKey in sources) {
                if (!sources.hasOwnProperty(sourceKey)) continue;
                if (angular.isDefined(sourceId) && sourceKey !== sourceId) continue;
                for (var sourceState in sourceStates) {
                    if (!sourceStates.hasOwnProperty(sourceState)) continue;
                    if (angular.isDefined(stateName) && stateName !== sourceState) continue;
                    if (angular.isDefined(sources[sourceKey][sourceState]) &&
                        (!sourceStates[sourceState].idleStates ||
                        !sourceStates[sourceState].idleStates.includes(
                            sources[sourceKey][sourceState]))) {
                        // Determine source equipmentId/sourceId so we don't count
                        // the same equipment source more than once.
                        var capsSource = sutl.getNode(RoomService.getRoom(),
                            ['configuredCaps', 'displays', displayKey, 'sources', sourceKey]);
                        if (capsSource === null) continue;
                        var activeContentSourcesPath =
                            [capsSource.equipmentId, capsSource.videoInputId, sourceState];
                        if (!sutl.getNode(activeContentSources, activeContentSourcesPath, false)) {
                            count++;
                        }
                        sutl.setNode(activeContentSources, activeContentSourcesPath, true);
                    }
                }
            }
            return count;
        }
    }

    function getFormattedElapsedTime(displayId, sourceId, startTimeProp) {
        var startTime = sutl.getNode(RoomService.getRoom(),
            ['states', 'displays', displayId, 'sources', sourceId, startTimeProp], 0);
        return moment.duration(elapsedTimeNow - startTime).format('HH:mm:ss', { trim: false });
    }

    function getSourceStateInfo(stateName) {
        if (!angular.isDefined(stateName)) return sourceStates;
        if (!sourceStates.hasOwnProperty(stateName)) {
            throw new Error('stateName: ' + stateName + ' does not exist!');
        }
        return sourceStates[stateName];
    }
}

module.exports = DisplaySourceStateService;
